module.exports = __webpack_public_path__ + "34db3d872f08b1dd7553a7ffbfc3f199.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-pink-s.png
// module id = 2734
// module chunks = 0